import type {
    FeedsState,
    LiveTableState,
    LiveTableType,
} from "@atg-casino-shared/types-feed";
import {
    type FeedsAction,
    RECEIVE_WIN_FEED,
    RECEIVE_JACKPOT_FEED,
    RECEIVE_LIVE_TABLE_FEED,
    ADD_WINNER_FEED_GAME,
} from "./feed.types";

export const createJackpotKey = (supplier: string, jackpotId: string): string =>
    `${supplier.toLowerCase()}-${jackpotId}`;

const MAX_WINNER_FEED_GAME_COUNT = 20;

export const feedReducer = (
    state: FeedsState = {jackpotFeed: {}, liveTableInfoFeed: {}, winners: []},
    action: FeedsAction,
) => {
    switch (action.type) {
        case RECEIVE_WIN_FEED: {
            return {...state, winFeed: action.payload};
        }
        case ADD_WINNER_FEED_GAME: {
            const {winners} = state;

            const nextWinners = [...winners];

            if (
                !nextWinners.some(
                    (o) => o.walletTimestamp === action.payload.walletTimestamp,
                )
            ) {
                nextWinners.unshift(action.payload);

                if (nextWinners.length > MAX_WINNER_FEED_GAME_COUNT) {
                    nextWinners.length = MAX_WINNER_FEED_GAME_COUNT;
                }
            }

            return {...state, winners: [...nextWinners]};
        }
        case RECEIVE_JACKPOT_FEED:
            return {
                ...state,
                jackpotFeed: action.payload.reduce(
                    (a, j) => ({
                        ...a,
                        [createJackpotKey(j.supplier, j.jackpotId)]: j,
                    }),
                    {},
                ),
            };
        case RECEIVE_LIVE_TABLE_FEED:
            return {
                ...state,
                liveTableInfoFeed: action.payload.reduce(
                    (acc: LiveTableState, liveInfo: LiveTableType) => {
                        acc[liveInfo.tableId] = {
                            ...liveInfo,
                            tableIsFull: liveInfo.availableSeats === 0,
                        };
                        return acc;
                    },
                    {},
                ),
            };
        default:
            return state;
    }
};
